export const SCRIPT_STATUS_ATTRIBUTE = 'data-status';
